import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("api/sso/token");

const getTokenAsync = (params) => {
    return remoteCall.invoke("getToken", params);
};

const generateSymmetricEncryptedTokenAsync = (params) => {
    return remoteCall.invoke("generateSymmetricEncryptedToken", params);
};

export default {
    getTokenAsync,
    generateSymmetricEncryptedTokenAsync,
};
